import { FC } from "react";
import { MultiSelectChoice, Option, SelectProps } from "app/component/form/select/MultiSelectChoice";
import { TestType } from "app/api/graph/types";
import { testTypeLabel } from "app/api/graph/strings";

type Props = SelectProps & {
    values: TestType[];
    onChange: (values: TestType[]) => void;
};

const options: Option[] = [
    TestType.WebApp,
    TestType.InternalInfrastructure,
    TestType.ExternalInfrastructure,
    TestType.Wifi,
    TestType.Phishing,
    TestType.RedTeamAssessment,
    TestType.InternalExternalInfra,
    TestType.AppInfraCloud,
    TestType.CloudAssessment,
    TestType.PenetrationTest,
    TestType.Llm,
    TestType.DesktopApp,
    TestType.MobileApp,
    TestType.Api,
    TestType.PurpleTeamAssessment,
    TestType.Kubernetes,
    TestType.SapTesting,
    TestType.PhysicalPenetrationTesting,
    TestType.BlackBox,
    TestType.GreyBox,
    TestType.WhiteBox,
    TestType.SocialEngineering,
    TestType.BlindTesting,
    TestType.DoubleBlindTesting,
    TestType.IotAndEmbedded,
    TestType.NotSpecified,
].map((value) => ({
    label: testTypeLabel(value),
    value: value,
}));

export const SelectTestTypes: FC<Props> = ({ values, onChange, ...props }) => {
    return (
        <MultiSelectChoice
            {...props}
            options={options}
            value={values.map(
                (role) => options.find((option) => option.value === role) ?? { value: role, label: role },
            )}
            onChange={(options) => onChange(options.map((option) => option.value as TestType))}
        />
    );
};
